import { Container } from '@/components/layout';
import { HomeContent } from '@/components/composed';

export function HomePage() {
  return (
    <Container maxWidth="full" className='overflow-auto'>
      <HomeContent />
    </Container>
  );
}
